/* eslint-disable */
import Vue from 'vue';
import moment from 'moment';
import rulesAPI from '../services/postData';
import common from '../services/common';

export const inputFieldMixin = {
  inject: ['$validator'],
  data() {
      return {
        field_rules: { required: false }, // Default rule for input validation
        apiRule: {
          present: false,
          type: '',
          url: '',
        },
        state: {
          format: 'MM/DD/YYYY',
          date: new Date(),
          disabledDates: {
            to: new Date(1910, 1, 1), // Disable all dates up to specific date
            from: new Date(2120, 1, 1), // Disable all dates after specific date
          },
        },
      }
  },
  created() {
     if (this.fieldData.rules) {
       for (let arrayCnt = 0; arrayCnt < this.fieldData.rules.length; arrayCnt += 1) {
        if (this.fieldData.rules[arrayCnt].rule_type === 'api') {
          this.apiRule.present = true;
          this.apiRule.url = this.fieldData.rules[arrayCnt].rule_url;

          switch (this.fieldData.rules[arrayCnt].trigger) {
            case 'onchange':
              this.apiRule.type = 'onchange';
              break;
            case 'onblur':
              this.apiRule.type = 'onblur';
              break;
            default:
          }
        }
      }
    }
  },
  mounted() {

    // TODO: Don't allow invalid dates to be present in the app. This is related to CL #1451492 .
    if (this.fieldData.field_value === 'Invalid date') {
      this.fieldData.field_value = '';
    }
    this.get_field_rules();
  },
  computed: {
    disabled_dates: {
      cache: false,
      get: function () {
        return this.state.disabledDates;
      },
      set: function (disabledDateValues) {
        this.state.disabledDates = disabledDateValues;
      },
    },
    isEmpty() {
      return (this.fieldData.field_value === '' || this.fieldData.field_value === 'Invalid date' || this.fieldData.field_value === null);
    },
    isErrorMessageRequired() {
      return (this.fieldData.error === 'Required.'); // TODO: Use config value
    },
  },
  methods: {
    /**
     * Calculates the width of this component based on the data.
     * TODO: Refactor to be more universal rather than only for width.
     */
    fieldStyles(inputMask) {
      let fieldWidth = '50%';

      if (inputMask !== undefined) {
        fieldWidth = inputMask.length + 2 + 'em';
      } else if (this.fieldData.max_length < 100) {
        fieldWidth = this.fieldData.max_length + 4 + 'em';
      }

      return `width: ${fieldWidth}; max-width: 100%;`;
    },
    /**
     * If there are issues with getting the validation rules for an input element,
     * then that input element will use a blank set of rules.
     */
    get_field_rules_fallbacks() {
      this.field_rules = {}; // Use no rules
    },
    moment: function (newDate) {
      let dateParts;

      if (!newDate) {
        return moment();
      }

      if (typeof newDate.getMonth === 'function') {
        return moment(newDate);
      }

      dateParts = newDate.split('/');

      return moment(new Date(dateParts[2], (dateParts[0] - 1), dateParts[1]));
    },
    get_field_rules() {
      if (!this.fieldData.rules) {
        this.get_field_rules_fallbacks(); // No rules exist, so use fallback rules.
        return;
      }

      // TODO: Possibly update API response to forego looping through the rules.
      this.fieldData.rules.forEach((rule) => {
        if (rule.rule_type === 'js') {
          try {
            this.field_rules = JSON.parse(rule.rule); // Set rules

             // A rule with a `regex` property needs to be converted from string to
             // a JavaScript RegExp object.
            if (typeof this.field_rules.regex !== 'undefined') {
              this.field_rules.regex = new RegExp(this.field_rules.regex);
            }
          } catch (e) {

             // There was an error in parsing the JSON, so instead of breaking on the error,
             // the fallback rules will be used.
            this.get_field_rules_fallbacks();
          }
        }
      });

      if (typeof this.field_rules === 'undefined') {
        this.get_field_rules_fallbacks(); // No 'js' rules exist, so use fallback rules.
      }

      /**
       * Set disabled dates according to this form data's validation rules. This is only
       * used for "date_short" field types because those use the datepicker which has the
       * ability to disable the user from clicking certain date ranges.
       */

      if (
        this.fieldData.field_type === 'date_short' &&
        this.field_rules &&
        this.field_rules.within_custom_date_range || this.field_rules.within_custom_date_range_reports
      ) {
        let min; // Minimum magnitude (used in conjunction with time_unit_min)
        let max; // Maximum magnitude (used in conjunction with time_unit_max)
        let format; // Built-in rule 'date_between' requires the date format
        let minDate;
        let maxDate;
        let timeUnitMin; // Unit of time (days, weeks, months, years)
        let timeUnitMax; // Unit of time (days, weeks, months, years)
        let isItBetween;

        [min, max, timeUnitMin, timeUnitMax, format] = this.field_rules.within_custom_date_range ? this.field_rules.within_custom_date_range : this.field_rules.within_custom_date_range_reports;
        this.state.format = format;
        minDate = this.moment().subtract(min, timeUnitMin).format(format);
        maxDate = this.moment().add(max, timeUnitMax).format(format);
        
        this.disabled_dates = {
          to: new Date(this.moment(minDate).format()),
          from: new Date(this.moment(maxDate).format()),
        };
      }

      // Store field names of fields that will compare their dates to one another in their validation rule
      if (typeof this.field_rules.has_time_between !== 'undefined') {
        sessionStorage.setItem(`found_date_${this.field_rules.has_time_between}`, this.fieldData.field_name);
      }

      // Store field names of fields that will compare their dates to one another in their validation rule
      if (typeof this.field_rules.has_compare_integers !== 'undefined') {
        sessionStorage.setItem(`found_integer_${this.field_rules.has_compare_integers}`, this.fieldData.field_name);
      }
    },
    /* Set multiswitch  values */
    /* eslint no-param-reassign:  */
    setMultiSwitchValue(subItem, formData) {
      let valCheck = false;
      let sepArr = formData.field_value.split(',');
      for (let cnt = 0; cnt < sepArr.length; cnt++) {
        if (sepArr[cnt] === subItem.internal_value) {
          valCheck = true;
        }
      }
      if (valCheck) {
        if (formData.field_value.includes(',')) {
          let existArr = formData.field_value.split(',');
          let tempVal = '';
          for (let vCnt = 0; vCnt < existArr.length; vCnt += 1) {
            if (subItem.internal_value !== existArr[vCnt]) {
              if (tempVal === '') {
                tempVal += existArr[vCnt];
              } else {
                tempVal += `,${existArr[vCnt]}`;
              }
            }
          }
          formData.field_value = tempVal;
        } else {
          formData.field_value = '';
        }
      } else if (formData.field_value === '') {
        formData.field_value = subItem.internal_value;
      } else {
        formData.field_value = `${formData.field_value},${subItem.internal_value}`;
      }
      if (this.apiRule.present) {
        this.postRule(formData.field_value, formData);
      }
    },
     /* Get multiswitch status values */
     getMultiSwitchStatus(subItem, formData) {
      let sepArr = formData.field_value.split(',');
      for (let cnt = 0; cnt < sepArr.length; cnt++) {
        if (sepArr[cnt] === subItem.internal_value) {
          return true;
        }
      }
      return false;
    },
    /**
     * execute rule based on api response
     */
    postRule() {
     this.sendPostRule(this.apiRule.url);
    },
    /**
     * Disabled field data is supposed to be visible to the user but not interactive. This
     * method is used for adding the `disabled` attribute, for styling, and for disallowing
     * interaction with the element.
     */
    showDisabled() {
      let showDisabled = true;

      // T/T
      if (this.fieldData.is_enabled && this.fieldData.visible) {
        showDisabled = false;
      }

      // F/T
      if (!this.fieldData.is_enabled && this.fieldData.visible) {
        showDisabled = 'disabled-field';
      }

      // X/F
      if (!this.fieldData.visible) {
        showDisabled = 'hidden-field';
      }
      if (this.$store.state.buttonState.quoteSummaryData && this.$store.state.buttonState.quoteSummaryData.quote_status === 'Bound') {
        showDisabled = true;
      }
      if (this.$store.state.buttonState.quoteSummaryData && this.$store.state.buttonState.quoteSummaryData.quote_status === 'Bound' && sessionStorage.getItem('flowType') === 'bundle' && this.$router.currentRoute.path.includes('/checkout')) {
        if (this.fieldData.field_name.includes('QTE_PRP_')) {
          showDisabled = this.$store.getters.getHomeBindStatus && this.$store.getters.getHomeBindStatus.Status === 'Success' ? true : false;
        } else {
          showDisabled = this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success' ? true : false;
        }
      }
      return showDisabled;
    },
    /**
     * single radio control to store value in vuex store and call rule if exists
     */
    selectSingleRadio(formData, value) {
      if (sessionStorage.getItem('flowType') === 'bundle' && formData.field_name === 'QTE_PRP_BillPlan') {        
        this.$store.dispatch('setHomeBillingPlan', formData.field_value);
      } else {
        this.$store.dispatch('setBillingPlan', formData.field_value);
      }
      console.log('setBillingPlan called',formData.field_value);
      if (this.apiRule.present) {
        this.postRule(formData.field_value, formData);
      }
    },
    /**
     * single radio control to store value in vuex store and call rule if exists
     */
    selectSingleRadioVIN(formData, value) {
      this.fieldData.field_value = value;
      if (this.apiRule.present) {
        this.postRule(formData.field_value, formData);
      }
    },
    /**
     * set radio control value also treat as switch control. Also call API rule if exists
     * @param {*} formData
     * @param {*} switchVal
     */
    setSwitchValue(formData, switchVal) {
       if (formData.is_enabled && (!this.showDisabled())) {
        const switchId = formData.field_name;
        // if (document.getElementById(switchId).value === switchVal) {
        //  this.$validator.validate(switchId);
        //   return;
        // }
        document.getElementById(switchId).value = switchVal;
        this.fieldData.field_value = switchVal;
        for (let arrayCnt = 0; arrayCnt < this.fieldData.rules.length; arrayCnt += 1) {
           if (this.fieldData.rules[arrayCnt].rule_type === 'api') {
            this.apiRule.present = true;
            this.apiRule.url = this.fieldData.rules[arrayCnt].rule_url;
          }
        }
         if (this.apiRule.present) {
         this.postRule(this.fieldData.field_value, formData);
       }
        this.$validator.validate(switchId);
      }
    },
    /**
     * Validating all of the fields on the validation event (ex: blur) is necessary to manually call
     * if there are masked inputs. This is because masked inputs use a custom component that do not
     * react to it's parent's events.
     * TODO: Refactor masked inputs to pass their validation event to their input child
     */
    validate_all_fields(fieldToValidate) {
      // TODO: Combine API + client validation errors
      this.fieldData.has_error = false; // Reset API errors to false upon any interaction

      this.$validator.validate(fieldToValidate).then((result) => {
        if (!result) {
          gtag('event', 'exception', {
            description: 'Invalid input data found',
            fatal: false, // set to true if the error is fatal
          });
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/inputFieldMixin.js